import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class TestCaseGrid extends BaseComponent {
	
	static get properties() {
		return {				
		};
	}
	
	constructor() {
		super();
		
		var testCaseGrid = this;
		setTimeout(function(){
			testCaseGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var testCaseGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'run',
					theme: 'primary',
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_SYSTEM_TEST:EXECUTE'],
					children:[
						ElementUtil.makeIcon('vaadin:bolt', ' Run')
					],
					listeners: {
						click: function() {							
							actionRun(grid.selectedItems);
						}
					}					
				}				
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column'
			},			
			children: [	
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}
					
				},
				{						
					path: 'name',
					header: 'TestName',
					resizable: true,
					width: '7em'
				},
				{						
					path: 'category',
					header: 'Category',
					resizable: true,
					width: '9em'
				},	
				{						
					path: 'className',
					header: 'Class Name',
					resizable: true,
					width: '7em'
				},
				{						
					path: 'fullClassName',
					header: 'Full Class Name',
					resizable: true,
					width: '10em'
				},				
				{						
					path: 'description',
					header: 'Description',
					resizable: true,
					width: '10em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					
					setTimeout(function() {
						gridSelectionChange();
					});
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
		
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {	
					ElementUtil.query(toolbar, 'run').disabled = false; 
				} else {						
					ElementUtil.query(toolbar, 'run').disabled = true;
				}
			});
		};
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		testCaseGrid.append(flexLayout);		
				
		var actionRefresh = function() {
			var loadMask = grid.showLoading();	
			Service.getTestCaseService().getTestCases().then(function(data){
				loadMask.remove();
				
				grid.activeItem = null;
				grid.items = data;				
			});
		};
		actionRefresh();
		
		var actionRun = function(records) {
			
			var startTest = function(stack, params) {
				//open output window
				
				var outputWin = ElementUtil.create({
					tag: 'dl-dialog',
					title: 'Test Output',
					icon: 'vaadin:bolt',
					width: 800,
					height: .8,
					listeners: {
						ready: function() {						
							outputWin.show();
							
							var content = ElementUtil.create({
								tag: 'div',
								slot: 'primary'
							});
							
							var status = ElementUtil.create({
								tag: 'div',
								style: 'border: 1px solid black; padding: 5px; background-color: aliceblue; color: black;',
								slot: 'footer',
								innerHTML: 'Test: Pending'
							});
							
							var flexContainer = ElementUtil.create({
								tag: 'dl-flex-layout',
								children: [
									content,
									status
								]
							});
							
							outputWin.addToContentElement(flexContainer);
							
							var stats = {
								successCount: 0,
								failedCount: 0
							};
							var performRun = function(runRecord) {
								if (!runRecord) {
									
									//update stat
									var statsText = `
										<div>
											<b>Successful Runs</b>: ${stats.successCount}<br>
											<b>Failed Runs</b>: ${stats.failedCount}<br>
										</div>	
									`;
									
									var statsPanel = ElementUtil.create({
										tag: 'dl-section-panel',
										style: 'margin-top: 10px',
										title: 'Final Results',
										children: [
											{
												tag: 'div',
												slot: 'content',
												innerHTML: statsText
											}
										]									
									});
									content.append(statsPanel);
									status.innerHTML = 'Done. Completed: ' + (stats.successCount + stats.failedCount);
									
									return;
								}
								
								status.innerHTML = 'Running Test: ' + runRecord.name;
								
								var outputPanel = ElementUtil.create({
									tag: 'dl-section-panel',
									title: 'Test: ' + runRecord.name,
									children: [
										{
											tag: 'div',
											itemid: 'testOutput',
											slot: 'content',
											trustedInnerHTML: true,
											innerHTML: '<div style="height: 50px;"></div>'
										}
									]
								});
								content.append(outputPanel);
								
								var loadMask = outputPanel.showLoading('Running test...');
								Service.getTestCaseService().runTest(runRecord.className, params).then(function(result){
									loadMask.remove();
									
									var testOutput = ElementUtil.query(outputPanel, 'testOutput');
									
									var successMessage = 'Success';
									if (result.success) {
										stats.successCount++;
										testOutput.style['background-color'] = 'rgb(96 132 96)';
									} else {
										successMessage = 'Failed';
										stats.failedCount++;
										testOutput.style['background-color'] = 'rgb(214 122 122)';
									}
									
									var textOfResults = `
										<h2>${successMessage}</h2>
										<div>Runtime: ${TimeUtil.milliToDisplay(result.testRunTime)}
										<br>
									`;
									result.messages.forEach(function(message){
										textOfResults += `
											<div>
												<b>${message.type}</b> - ${TimeUtil.formatDateStandard(message.messageTime)} : ${message.message}
											</div>
										`;										
									});
									testOutput.innerHTML = textOfResults;									
																		
									performRun(stack.pop());									
								}).catch(function(error){
									var testOutput = ElementUtil.query(outputPanel, 'testOutput');
									testOutput.style['background-color'] = '#ffb3b3';
									testOutput.innerHTML = 'Failed to run. Response Code: ' + error.res.status;
									stats.failedCount++;
									performRun(stack.pop());
								});								
								
							};
							performRun(stack.pop());							
							
						}
					}
				});
			};	
			
			if (records.length === 1) {
				//prompt for parameters
				
				var runWin = ElementUtil.create({
					tag: 'dl-dialog',
					title: 'Run Test: ' + records[0].name,
					icon: 'vaadin:play-circle',
					width: .8,
					height: 400,
					listeners: {
						ready: function() {						
							runWin.show();

							var formPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [
									{
										tag: 'fieldset',											
										children: [
											{
												tag: 'legend',
												innerHTML: 'Parameters'
											},
											{
												tag: 'dl-toolbar',													
												theme: 'spacing',
												children: [
													{
														tag: 'vaadin-button',													
														'class': 'spacer-toolbar-item',
														children:[
															ElementUtil.makeIcon('vaadin:plus', ' Add')
														],
														listeners: {
															click: function() {							
																actionAddProperty();
															}
														}
													},
													{				
														tag: 'vaadin-button',						
														itemid: 'deleteProp',
														theme: 'error primary',													
														disabled: true,
														'class': 'spacer-toolbar-item',
														style: 'float: right;',
														children:[
															ElementUtil.makeIcon('vaadin:trash', ' Delete')
														],
														listeners: {
															click: function() {		
																var propGrid = ElementUtil.query(formPanel, 'propGrid');
																var selectedProp = propGrid.selectedItems[0];
																var props = ElementUtil.query(formPanel, 'propGrid').items;

																var newProps = [];
																props.forEach(function(prop){
																	if (prop.key !== selectedProp.key || prop.value !== selectedProp.value) {
																		newProps.push(prop);
																	}
																});
																ElementUtil.query(formPanel, 'propGrid').items = newProps;
																propGrid.clearCache();
																ElementUtil.query(formPanel, 'deleteProp').disabled = true;
															}
														}																	
													}
												]
											},
											{
												tag: 'vaadin-grid',
												itemid: 'propGrid',
												theme: 'row-stripes column-borders',
												'column-reordering-allowed': '',
												style: 'height: 200px;',			
												slot: 'primary',
												defaults: {
													tag: 'vaadin-grid-sort-column',
													resizable: true
												},			
												children: [				
													{						
														path: 'key',
														header: 'Key',					
														width: '9em'
													},
													{						
														path: 'value',
														header: 'Value',					
														'flex-grow': '1'
													}
												],
												listeners: {
													'active-item-changed': function(event) {
														const item = event.detail.value;
														var propGrid = ElementUtil.query(formPanel, 'propGrid');
														propGrid.selectedItems = item ? [item] : [];
														if (propGrid.selectedItems.length > 0) {
															ElementUtil.query(formPanel, 'deleteProp').disabled = false;					
														} else {
															ElementUtil.query(formPanel, 'deleteProp').disabled = true;
														}	
													}
												}											
											}
										]
									},
									{
										tag: 'hr',
										colspan: 2
									},
									{
										tag: 'div',
										style: 'text-align: center;',
										colspan: 2,
										defaults: {
											tag: 'vaadin-button'
										},
										children: [
											{
												theme: 'primary',
												children: [
													ElementUtil.makeIcon('vaadin:play-circle', ' Run Now')
												],
												listeners: {
													click: function() {
														actionRun(true);
													}
												}
											},
											{
												theme: 'secondary',
												style: 'margin-left: 10px;',
												children: [
													ElementUtil.makeIcon('vaadin:play-circle', ' Run (keep open)')
												],
												listeners: {
													click: function() {
														actionRun(false);
													}
												}
											},
											{
												theme: 'tertiary',
												innerHTML: 'Cancel',
												style: 'margin-left: 10px;',
												listeners: {
													click: function() {
														//cancel
														runWin.close();
													}
												}
											}
										]
									}								

								]

							});
							runWin.addToContentElement(formPanel);

							var actionRun = function(closeWin) {

								var data = {};
								if (!data.parameters) {
									data.parameters = {};
								}

								var props = ElementUtil.query(formPanel, 'propGrid').items;
								if (props && props.length > 0) {
									props.forEach(function(prop){
										data.parameters[prop.key] = prop.value;
									});						
								}
								
								if (closeWin) {
									runWin.close();
								}
								
								var testStack = records.slice(0);
								startTest(testStack, data);								
								
							};


							var actionAddProperty = function() {
								var addPropWin = ElementUtil.create({
									tag: 'dl-dialog',
									title: 'Add Parameter',
									icon: 'lumo:edit',
									width: 500,
									height: 250, 
									listeners: {
										ready: function() {						
											addPropWin.show();

											var propFormPanel = ElementUtil.create({
												tag: 'dl-form-panel',
												itemid: 'form',
												children: [
													{
														tag: 'vaadin-form-layout',										
														children: [
															{
																tag: 'vaadin-text-field',
																label: 'Key',
																name: 'key',
																required: true,
																maxlength: 255
															},
															{
																tag: 'vaadin-text-field',
																label: 'Value',
																name: 'value',
																maxlength: 255,
																required: true
															},
															{
																tag: 'hr',
																colspan: 2
															},
															{
																tag: 'div',
																style: 'text-align: center;',
																colspan: 2,
																defaults: {
																	tag: 'vaadin-button'
																},
																children: [
																	{
																		theme: 'primary',
																		children: [
																			ElementUtil.makeIcon('vaadin:database', ' Save')
																		],
																		listeners: {
																			click: function() {
																				if (propFormPanel.isValid()) {
																					var data = propFormPanel.getData();
																					var propGrid = ElementUtil.query(formPanel, 'propGrid');
																					if (!propGrid.items || propGrid.items.length === 0) {
																						propGrid.items = [];
																					} 																			
																					propGrid.items.push(data);
																					propGrid.clearCache();

																					addPropWin.close();
																				}	
																			}
																		}
																	},
																	{
																		theme: 'tertiary',
																		innerHTML: 'Cancel',
																		style: 'margin-left: 10px;',
																		listeners: {
																			click: function() {
																				//cancel
																				addPropWin.close();
																			}
																		}
																	}
																]
															}
														]
													}
												]

											});
											addPropWin.addToContentElement(propFormPanel);							
										}
									}
								});
							};

						}
					}
				});			
				
				
			} else {
				
				var runStack = records.slice(0);
				startTest(runStack, {
					parameters: {}
				});					
				
			}
			
		};
		
	}
	
};
customElements.define('dl-test-case-grid', TestCaseGrid);
